import { FC } from 'react';
import { useSelector } from 'react-redux';

import type { Section } from 'src/__generated__/graphqlTypes';
import Content from 'src/components/Content/Content';
import type { Store } from 'app-redux/types/storeTypes';
import { capitalizeFirstLetter } from 'lib/text.service';

const ContentContainer: FC = ({ children }) => {
  const slug = useSelector((store: Store) => store.server.page.slug);
  const page = useSelector((store: Store) => store.server.page.pages[slug]);
  const { contentCollection, relativeUrl, backgroundColor } = page;
  const content = contentCollection?.items as Array<Section>;

  if (!content?.length) {
    return null;
  }

  const className = relativeUrl
    ?.split('/')
    .filter((word) => Boolean(word))
    .map((word, i) => {
      const compleatWord = word
        .split('-')
        .map((word, i) => ((i === 0) ? word : capitalizeFirstLetter(word)))
        .join('');

      return ((i === 0) ? compleatWord : capitalizeFirstLetter(compleatWord));
    })
    .join('');

  return (
    <>
      {children}
      <Content
        content={content}
        className={className || slug}
        bgColor={backgroundColor}
      />
    </>
  );
};

export default ContentContainer;
